const Checkbox = ({attribute, id, placeholder = null, label = null, action = null, required = true }) => {
    return (
        <div className="flex gap-2">
            <input
                type={"checkbox"}
                id={id}
                value={attribute}
                onChange={action}
                placeholder={placeholder}
                required={required}
                checked={attribute}
                className="mt-1 block px-3 py-2 text-lg border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
            />
            {label && <label htmlFor= {id} className="block text-lg font-medium text-gray-700">
                {label} {required === true && "*"}
            </label>}
        </div>
    )
}
export default Checkbox